import { AxiosInstance } from 'axios';
import i18next from 'i18next';
import { useQuery } from 'react-query';
import { axiosNoAuth } from './axios';
import { NavigationTranslationsType } from '../types/NavigationTranslationsType';
import { i18nAppend } from '../helpers/i18nAppend';

const NAVIGATION_QUERY_KEY = ['navigation'] as const;

const appendNavigationTranslations = (navigationTranslations: NavigationTranslationsType) => {
  i18nAppend(navigationTranslations.header, 'header', {
    id: 0,
    languages_code: '',
    mkt_header_id: '',
    cathay_link_icon_alt_text: '',
    cathay_link_text: '',
    cathay_link_link: '',
    cathay_logo: '',
    cathay_logo_alt_text: '',
    navigation: [],
    support_icon_alt_text: '',
    support_link: '',
    support_text: '',
    portal_text: '',
    portal_link: ''
  });

  i18nAppend(navigationTranslations.footer, 'footer', {
    contact_sns: [{
      logo: '',
      link: '',
      icon_alt_text: '',
      platform_key: '',
    }],
    contact_text: '',
    copyright: '',
    id: 0,
    languages_code: '',
    mkt_footer_id: '',
    contact_us_text: '',
    contact_us_link: '',
    terms_and_conditions_text: '',
    terms_and_conditions_link: '',
    cookie_policy_text: '',
    cookie_policy_link: ''
  });
};

export const getNavigationTranslations = async (axios: AxiosInstance) => {
  const response = await axios.get<NavigationTranslationsType>('/hackathon-cms/v1/marksite/navigation');

  appendNavigationTranslations(response.data);

  return response.data;
};

export const useNavigationTranslationsQuery = () => {
  return useQuery<NavigationTranslationsType>({
    queryKey: NAVIGATION_QUERY_KEY,
    queryFn: () => getNavigationTranslations(axiosNoAuth),
    staleTime: Infinity,
    retry: 2,
    refetchOnWindowFocus: false,
  });
};

export const getHeaderTranslations = (navigationTranslations: NavigationTranslationsType) => {
  return (navigationTranslations.header[0]?.navigation ?? []).map((_, index) => index);
};

export const getFooterTranslations = (navigationTranslations: NavigationTranslationsType) => {
  return navigationTranslations.footer.find((footer) => footer.languages_code === i18next.language) ?? navigationTranslations.footer[0];
};